export const personalUserFields = [
  'id',
  'firstName',
  'lastName',
  'username',
  'emoji',
  'age',
  'ratings',
  'ratingDisplayMode',
  'notificationPreferences',
  'playerTypes',
  'title',
  'profileImageBlobHash',
  'chessBoardImageBlobHash',
  'city',
];

const handshakeFields = ['handshakeCount', 'isHandshakeConfirmed', 'isHandshakePending'];

const relationshipFields = ['isFollowed', 'isFollowingMe'];

export const baseUserFields = [
  ...personalUserFields,
  ...handshakeFields,
  ...relationshipFields,
  'rating',
  'status',
  'distance',
  'featured',
];

export const adminUserFields = [
  ...personalUserFields,
  'createdAt',
  'email',
  'isGambitsMaster',
  'loginProvider',
  'lastActiveAt',
];

export const ratingsFields = [
  'lichessComClassicalRating',
  'lichessComRapidRating',
  'lichessComBlitzRating',
  'lichessComBulletRating',
  'chessComBlitzRating',
  'chessComRapidRating',
  'chessComBulletRating',
  'chessComClassicalRating',
  'fideRating',
  'rating',
];

export const baseUserInfoFields = [
  ...personalUserFields,
  'email',
  'phone',
  'birthDate',
  'aboutMe',
  'provider',
  'location',
  'isAdmin',
  'clubs',
  'blocked',
  'unitType',
  'accentHue',
  ...ratingsFields,
  'handshakeCount',
];

export const userInfoFields = [
  ...personalUserFields,
  ...ratingsFields,
  'email',
  'phone',
  'birthDate',
  'aboutMe',
  'provider',
  'location',
  'isAdmin',
  'clubs',
  'blocked',
  'unitType',
  'accentHue',
  'recentClockControls',
  'cityId',
  'city',
  'handshakePartnerIds',
  'positionPartnerIds',
];

export const detailUserFields = [
  'id',
  'firstName',
  'lastName',
  'username',
  'emoji',
  'ratings',
  'ratingDisplayMode',
  'playerTypes',
  'isGambitsMaster',
  'title',
  'profileImageBlobHash',
  'aboutMe',
  'clubs',
  'age',
  'upcomingGambits',
  'followers',
  'following',
  'isFollowed',
  'isFollowingMe',
  'createdAt',
  'lichessComClassicalRating',
  'lichessComRapidRating',
  'lichessComBlitzRating',
  'lichessComBulletRating',
  'chessComBlitzRating',
  'chessComRapidRating',
  'chessComBulletRating',
  'chessComClassicalRating',
  'fideRating',
  'rating',
  'isHandshakePending',
  'isHandshakeConfirmed',
  'pendingHandshakes',
  'handshakeCount',
  'handshakes',
];
